import type { SupplierProductDTO } from '../dto'

export type IntegrationStatus = 'ONLINE' | 'OFFLINE' | 'DEGRADED' | 'CIRCUIT_OPEN'

export type IntegrationOperation =
  | 'authenticate'
  | 'refreshAuthentication'
  | 'searchProducts'
  | 'getProduct'
  | 'getStock'
  | 'getPrice'
  | 'healthCheck'
  | 'disconnect'
  | 'http'

export interface SupplierResponse<T = unknown> {
  supplier: string
  status: 'success' | 'error' | 'partial'
  executionTime: number
  requestId: string
  items: T[]
  errors: string[]
  warnings: string[]
}

export interface IntegrationLog {
  id: string
  supplierId: string
  requestId: string
  operation: IntegrationOperation | string
  status: string
  duration: number
  errorMessage: string | null
  createdAt: string
}

export interface IntegrationHealth {
  supplierId: string
  status: IntegrationStatus
  latency: number
  lastCheck: string
  lastSuccess: string | null
  lastFailure: string | null
  averageLatency: number
  cacheHitRate: number
  lastSync: string | null
  failureCount: number
}

export interface IntegrationConfig {
  timeoutMs: number
  maxRetries: number
  cacheTtlMs: number
  concurrency: number
  rateLimitPerMinute: number
  circuitFailureThreshold: number
  circuitOpenMs: number
}

export interface IntegrationDashboard {
  averageLatency: number
  maxLatency: number
  unavailableCount: number
  cacheHitRate: number
  suppliers: IntegrationHealth[]
}

export type SupplierProductResult = SupplierResponse<SupplierProductDTO>

export const DEFAULT_INTEGRATION_CONFIG: IntegrationConfig = {
  timeoutMs: 8000,
  maxRetries: 3,
  cacheTtlMs: 60_000,
  concurrency: 4,
  rateLimitPerMinute: 60,
  circuitFailureThreshold: 5,
  circuitOpenMs: 30_000,
}
